<template>
  <el-form
    :model="form"
    ref="form">
    <el-form-item
      :label="L10n('label-key')"
      prop="labelKey"
      :rules="getValidationRule('required,minLength')"
      class="material-style">
      <el-input
        ref="firstField"
        v-model.trim="form.labelKey"
        @change="updateModelItem('labelKey', { required: true })"/>
    </el-form-item>
    <el-form-item
      :label="L10n('title')"
      prop="title"
      :rules="getValidationRule('required,minLength')"
      class="material-style">
      <el-input
        :value="form.title"
        @input="form.title = valueTrimLeft($event)"
        @change="updateModelItem('title', { required: true })"/>
    </el-form-item>
    <el-form-item
      :label="L10n('language')"
      prop="languageID"
      :rules="getValidationRule('requiredSelect')"
      class="material-style">
      <select-response
        :model.sync="form.languageID"
        @change="updateModelItem('languageID', { required: true })"
        :placeholder="L10n('choose')"
        :isLoading="languages.isLoading"
        :data="languages.records"/>
    </el-form-item>
  </el-form>
</template>

<script>
import Form from '@/components/Form/Form'

export default {
  name: 'FormLabel',
  mixins: [Form],
  computed: {
    languages () {
      return this.API('Languages/GetAllDynamic?select=id,title')
    }
  }
}
</script>
